// Shared display labels for WQI outcome groups. Single source of truth so
// StoryScreen2, the share-string generator, and any future surfaces render
// the same label for a given group key.

import { WQIGroupKey } from './waterQualityIndex.types'

export const WQI_GROUP_LABELS: Record<WQIGroupKey, string> = {
  health_safety: 'Health & Safety',
  home_infrastructure: 'Home Infrastructure',
  skin_laundry: 'Skin, Hair & Laundry',
  taste_odor: 'Taste Preferences',
}

// Canonical render order — keep in sync with the walkthrough's Screen 2.
export const WQI_GROUP_ORDER: WQIGroupKey[] = [
  'health_safety',
  'home_infrastructure',
  'skin_laundry',
  'taste_odor',
]
